import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import InputMask from "react-input-mask";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import moment from "moment";

const HourInput = (props) => {
	const hasValue = !!props.value;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const id = generateGuid();
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const info = props.tooltip ?
		<Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	let validation = props.validationMessage ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;

	let valueAsMoment = moment(props.value);
	let formatValue = valueAsMoment.isValid() ? moment(props.value).format("HH:mm") : (hasValue ? props.value : "");

	const inputClassName = classnames({
		"c-input__field": true
	});
	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": hasValue
	});

	const containerClassName = classnames({
		"c-input": true,
		"has-value": hasValue,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": props.disabled
	});

	let doParseBeforeOnChange = function (e) {
		let value = e.target.value;
		let hour = value.substring(0, 2);
		let minute = value.substring(3, 5);

		let cancel = false;
		if (hour[0] > 2) {
			value = value.substring(0, 0) + "0" + hour[0] + value.substring(1);
		}
		if (hour[0] === "2" && hour[1] > 3) {
			value = value.substring(0, 1) + "0" + hour[1] + value.substring(2);
		}
		if (minute[0] > 5) {
			value = value.substring(0, 3) + "0" + minute[0] + value.substring(4);
		}

		if (!cancel) {
			let valueAsMoment = moment(value);
			e.target.value = valueAsMoment.isValid() ? valueAsMoment : value;
			props.onChange(e);
		}
	};

	let doBeforeMaskedValueChange = (newState, oldState, userInput) => {
		let { value } = newState;
		let selection = newState.selection;
		let cursorPosition = value.replace(/[_:]/g, "").length;
		if(cursorPosition > 2)
		{
			cursorPosition++;
		}
		selection = { start: cursorPosition, end: cursorPosition };

		return {
			value,
			selection
		};
	};

	return (
		<div className={sizeClassName}>
			<div className={containerClassName}>
				<InputMask
					id={id}
					mask="99:99"
					value={formatValue}
					disabled={props.disabled}
					onChange={doParseBeforeOnChange}
					className={inputClassName}
					name={props.name}
					beforeMaskedValueChange={doBeforeMaskedValueChange} />
				<label
					className={labelClassName}
					htmlFor={id}>
					{label}
				</label>
				{info}
			</div>
			{validation}
		</div>
	);
};

HourInput.propTypes = {
	label: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.string
	]),
	disabled: PropTypes.bool,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	optional: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	fromRange: PropTypes.string,
	toRange: PropTypes.string
};

export default HourInput;
